<!-- 停检申诉单 sqm -->
<template>
  <appeal_componen :kindType="data.kindType" :getData="data.getData" v-if="data.getInfoFlag" @submit="submitBtn" @backBtn="routerBack"
    :subLoading="data.subLoading"></appeal_componen>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import appeal_componen from "../AppealComponent"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'Appeal',
    subLoading:false,
    getInfoFlag:false,
    getData:{}
  })

  const routerBack = () => {
    proxy.$router.back()
  }
  const submitBtn = (val) => {
     // 去除 inputDate
     val.inputDate = undefined;
    data.subLoading = true
    console.log('提交申诉')
    proxy.$http({
      url:"/base/RefusalAppeal/saveOrUpdate",
      method:"post",
      data:{
        ...val,
        badType:2189, // 停检单
        badTypename:'停检单',
        userId: data.supplyCode,
        badId:data.stopCheckId,
        stopCheckId:data.stopCheckId,
        ...data.getData,
        badDescribe:data.getData.stopReason,
        inputId : data.supplyCode,
        inputName: data.trueName,
        appealStatusid : 2144,
        flawMark: data.getData.stopReason,
        number : data.getData.unpassCount,
      }
    }).then(res=>{
      if(res.data.code == '0'){
        proxy.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message:res.data.data || h_i18n('801759cbd2cd6400747a8d4edc83b42b'), confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),callback:()=>{
          routerBack()
        }})
      }else{
        proxy.info(res.data.msg)
      }
    }).catch(res=>{

    }).finally(()=>{
      data.subLoading = false
    })
  }

  const getInfo = () => {
    proxy.startLoading(h_i18n('8f64f3e8f07e9b00a0eca21f01a208c6'))
    proxy.$http({
      url:'/base/RefusalAppeal/rejectsStop',
      method:'post',
      params:{
        stopCheckId:data.stopCheckId,
        supplyCode:data.supplyCode,
      }
    }).then(res=>{
      if (res.status == 200) {
        data.getData = res.data.data[0]
        data.getData.stopCheckId = data.stopCheckId
      }
    }).catch(err=>{
      
    }).finally(()=>{
      proxy.closeLoading()
      data.getInfoFlag = true
      // console.log(data.stopCheckId)
    })
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'Appeal'
      data.stopCheckId = route.query.stopCheckId ?  route.query.stopCheckId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.trueName = route.query.trueName || ''
    }
    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          proxy.$router.back()
        },})
      return
    }
    data.stopCheckId ? getInfo() : proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('e12a3630be263185d2e5c4418427aae4'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    callback: (action) => {
      proxy.$router.back()
    },})
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })

</script>

<style>

</style>